import { useState } from 'react';

import { useUpdateMyPreferences } from '@/api/mutations/user/useUpdateMyPreferences';
import useGetMe from '@/api/queries/me/useGetMe';
import {
  NO_TEAM_GROUP_ID,
  TeamRef,
  UNASSIGNED_GROUP_ID,
} from '@payaca/components/calendar/UserResourceCalendar';

export const useCollapsedScheduleGroups = (allTeams: TeamRef[]) => {
  const { preferences } = useGetMe();
  const { mutate: updateMyPreferences } = useUpdateMyPreferences();
  const [toggledGroupIds, setToggledGroupIds] = useState<string[]>();

  const collapsedGroupIds =
    toggledGroupIds ??
    (preferences ? (preferences.collapsedScheduleGroupIds ?? []) : undefined);

  const onGroupCollapsedChange = (groupId: string, isCollapsed: boolean) => {
    const knownGroupIds = new Set([
      UNASSIGNED_GROUP_ID,
      NO_TEAM_GROUP_ID,
      ...allTeams.map((team) => team.id),
    ]);
    const next = (collapsedGroupIds ?? []).filter(
      (id) => id !== groupId && knownGroupIds.has(id)
    );
    if (isCollapsed) next.push(groupId);

    setToggledGroupIds(next);
    updateMyPreferences({ collapsedScheduleGroupIds: next });
  };

  return { collapsedGroupIds, onGroupCollapsedChange };
};
